import { createAction, props } from '@ngrx/store';
import { IDataSeoPage } from '../../interfaces/IDataSeoPage';

export const dataSeoPaginaSuccess = createAction(
  '[Dada SEO Pagina] => dataSeoPaginaSuccess',
  props<{ dataSeoPage: IDataSeoPage }>()
);


